import noUiSlider from 'nouislider';

/**
 * Калькулятор партнёрского дохода на странице реферальной программы
 * (секция #incomeCalculator, разметка — referral-program.blade.php).
 *
 * Считает: оборот клиента × комиссия Speend × доля партнёра. Все три числа
 * приходят из разметки (data-атрибуты), а не зашиты здесь: доля партнёра и
 * границы ползунков — это условия программы, они меняются в lang/шаблоне
 * вместе с подписями, которые их же и называют («$100K», «20% partner share»).
 *
 * Ползунков ЧЕТЫРЕ, а не два: до 768px показывается мобильная карточка, с
 * 768px — пара карточек, и у каждой свои ползунки. Состояние одно на секцию,
 * поэтому одноимённые ползунки синхронизируются: смена ширины экрана не должна
 * сбрасывать введённое значение.
 */

function findLocale() {
  return document.documentElement.lang || 'en';
}

/** @return {{el: HTMLElement, name: string, min: number, max: number, step: number, start: number}|null} */
function readSliderConfig(el) {
  const config = {
    el,
    name: el.dataset.calcSlider,
    min: parseFloat(el.dataset.calcMin),
    max: parseFloat(el.dataset.calcMax),
    step: parseFloat(el.dataset.calcStep),
    start: parseFloat(el.dataset.calcStart),
  };

  const numbers = [config.min, config.max, config.step, config.start];

  return config.name && numbers.every(Number.isFinite) ? config : null;
}

function initCalculator(root) {
  const share = parseFloat(root.dataset.calcShare);

  if (!Number.isFinite(share)) return;

  const configs = Array.from(root.querySelectorAll('[data-calc-slider]'))
    .map(readSliderConfig)
    .filter(Boolean);

  // Состояние заполняется ДО создания ползунков: nouislider отдаёт `update`
  // сразу при создании, и первый же обработчик считает доход — со второй
  // величиной, ещё не прочитанной, вышло бы NaN на экране.
  const state = {};
  configs.forEach(({ name, start }) => {
    if (state[name] === undefined) state[name] = start;
  });

  if (state.turnover === undefined || state.fee === undefined) return;

  const locale = findLocale();
  const money = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 });
  const percent = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // Символ валюты дописываем сами, а не через style: 'currency': в макете он
  // стоит перед числом во всех локалях, а Intl в русской унёс бы его в конец.
  const formatMoney = (value) => '$' + money.format(Math.round(value));

  const render = () => {
    const monthly = Math.round(state.turnover * (state.fee / 100) * share);

    const values = {
      turnover: formatMoney(state.turnover),
      fee: percent.format(state.fee) + '%',
      monthly: formatMoney(monthly),
      annual: formatMoney(monthly * 12),
    };

    root.querySelectorAll('[data-calc-out]').forEach((out) => {
      const value = values[out.dataset.calcOut];

      if (value !== undefined) out.textContent = value;
    });
  };

  // Гасит эхо: `set()` сам поднимает `update`, и без флага синхронизация
  // мобильного и настольного ползунков ушла бы в рекурсию.
  let syncing = false;

  configs.forEach(({ el, name, min, max, step }) => {
    noUiSlider.create(el, {
      start: [state[name]],
      // Заливка только слева от ручки — «сколько набрано», а не диапазон.
      connect: [true, false],
      step,
      range: { min, max },
    });

    el.noUiSlider.on('update', (rawValues) => {
      if (syncing) return;

      state[name] = parseFloat(rawValues[0]);

      syncing = true;

      configs.forEach((other) => {
        if (other.el === el || other.name !== name) return;

        other.el.noUiSlider?.set(state[name]);
      });

      syncing = false;

      render();
    });
  });

  render();
}

export function initIncomeCalculator() {
  document.querySelectorAll('[data-calc-share]').forEach(initCalculator);
}
